module.exports = __webpack_public_path__ + "media/newstyle/images/icon-burger-purple-168f3221037e167085c884e458a31667.svg";